export class Deferred<T = any> {
	public reject: (reason?: unknown) => void;
	public resolve: (value?: T) => void;

	public readonly promise: Promise<T> = new Promise((resolve, reject) => {
		this.reject = reject;
		this.resolve = resolve;
	});
}
